import {
  Component,
  ElementRef,
  Input,
  NgModule,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash-es';
import {
  BackendSellDrugItemModel,
  BackendSellModel,
  SelectDrug,
} from '../../models/select-drug';
import { LoggerService } from 'src/app/services/logger.service';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { UserApiService } from '../../services/user-api.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { FloatLabelType } from '@angular/material/form-field';
import { FormControl, FormGroup } from '@angular/forms';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { PCTableActionInputModel } from '../../models/pc-table-action-input-model';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { TabelPaging } from '../../interfaces/table';
import { FocusableHTMLElement } from '../../interfaces/focusable-html-element';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  BuyImportRequestDrugModal,
  BuyImportRequestDrugStockModal,
  BuyImportRequestModal,
  BuyImportRequestValidationDrugModal,
  StockHelpItem,
} from '../../models/buy-import-modal';
import { Field } from '../../models/entity-defin';
import { debounceTime } from 'rxjs/operators';
import {
  FactorDetail,
  FactorDetailDrug,
  FactorStockItemDetailDrug,
} from '../../models/factor-detail';
import { ModalConfirm } from '../../models/modal-confirm';
import { CashMultiPaymentComponent } from '../../components/cash-multi-payment/cash-multi-payment.component';
import { Drug, DrugBackEndModel, DrugCode } from '../../models/drug';
import { DrugRequirementList } from '../../models/drug-requirement-list';
import { ProductType } from 'src/app/enum/product-type';
import { TranslateService } from '@ngx-translate/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NumericService } from 'src/app/services/numeric.service';
import { DropDownPagingInput } from 'src/app/models/drop-down-paging-input';
import { Guid } from 'src/app/services/guid';
import { PcsettingModalComponent } from '../../components/pcsetting-modal/pcsetting-modal.component';
import { SearchBoxComponent } from '../../components/search-box/search-box.component';
import { PCTableComponent } from '../../components/pctable/pctable.component';
import { Router } from '@angular/router';
import { FactorReportFilter } from '../../models/factor-report-filter';
import { FilterRange } from 'src/app/dashboard/models/filter-range';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-factor-table',
  templateUrl: './factor-table.component.html',
  styleUrl: './factor-table.component.css'
})
export class FactorTableComponent implements OnInit {
  public constructor(
    private logger: LoggerService,
    private guid: Guid,
    public router: Router,
    private modalService: NgbModal,
    public numericService: NumericService,
    private apiService: UserApiService,
    private renderer: Renderer2,
    private translate: TranslateService,
    public calendarService: NewCalendarService,
    private responseService: CustomizeResponseService,
    private database: DataService
  ) {
    this.filterData = new FactorReportFilter();
    this.stockList = [];
    this.stockHelpItem = new StockHelpItem();
    this.backendJson = new BuyImportRequestModal();
    this.productType = ProductType.Essentials;
    this.thisBarcodeValue = new DrugCode();
    this.editableItem = new BuyImportRequestDrugModal(
      this.calendarService.GetNow()
    );

    this.endPoint = '';
    this.getStockData();
    this.stockHelpItem = new StockHelpItem();
    this.thisValue = new FactorDetailDrug();

    this.searchRequestModel = new PCSearchRequestModel();

    this.requestModel = new PCSearchRequestModel();
    this.preInvoiceRequestModel = new PCSearchRequestModel();
    this.action = new PCTableActionInputModel(
      [
        {
          name: 'CreditMultiPayment',
          className: 'btn-outline-primary',
          icon: 'fa-regular fa-credit-card',
        },
        {
          name: 'CashMultiPayment',
          className: 'btn-outline-primary',
          icon: 'fa-solid fa-coins',
        },
        {
          name: 'Reload',
          className: 'btn-outline-primary',
          icon: 'bx bx-refresh',
        },
        {
          name: 'Settings',
          className: 'btn-outline-primary',
          icon: 'bx bx-cog',
        },
        {
          name: 'Filter',
          className: 'btn-outline-primary',
          icon: 'fas fa-filter',
        },
        {
          name: 'Add',
          className: 'btn-outline-primary',
          icon: 'bx bx-plus',
        },
        {
          name: 'Explanation',
          className: 'btn-outline-primary',
          icon: 'bx bx-question-mark',
        },
      ],
      'List of invoices',
      []
    );
  }

  floatLabelControl = new FormControl('always' as FloatLabelType);

  public thisItemIndex?: number;

  public selectDrugList: BuyImportRequestDrugModal[] = [];
  public editableItem: BuyImportRequestDrugModal;
  public editableItemMessage: BuyImportRequestValidationDrugModal =
    new BuyImportRequestValidationDrugModal();
  public searchWithBarcode: string = ``;
  public data?: PCTableInputModel;
  public preInvoiceData?: PCTableInputModel;
  public searchData?: PCTableInputModel;
  public activeAdd: boolean = true;
  public newItem: any = { count: '', stockId: '' };
  public currentFile: any;
  public level: number = 1;
  public fields: any[] = [];
  public searchFields: any[] = [];
  public factorDetail: FactorDetail = new FactorDetail();
  public thisValue: FactorDetailDrug;
  public DrugRequirements: DrugRequirementList = new DrugRequirementList();
  public stockHelpItem: StockHelpItem;

  @ViewChild('search') searchElement!: ElementRef;
  @ViewChild('organizationElement') organizationElement!: ElementRef;
  @ViewChild('count') countElement!: ElementRef;
  @ViewChild('nationalid') nationalCodeElement!: ElementRef;
  @ViewChild('drugSearchModal') drugSearchModalElement!: ElementRef;
  @ViewChild('factorDetailModal') factorDetailModalElement!: ElementRef;
  @ViewChild('factorReturnModal') factorReturnModalElement!: ElementRef;
  @ViewChild('searchFilter') searchFilterModal!: ElementRef;
  @ViewChild('removeLack') removeLackModalElement!: ElementRef;
  @ViewChild('printModal') printModalElement!: ElementRef;
  @ViewChild('printBtn') printBtnElement!: ElementRef;
  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;
  @ViewChild('CashAddModal') CashAddModal!: NgbPopover;
  @ViewChild('CreditAddModal') CreditAddModal!: NgbPopover;
  @ViewChild('CashMultiPayment') CashMultiPaymentModal!: NgbPopover;
  @ViewChild('CreditMultiPayment') CreditMultiPaymentModal!: NgbPopover;
  @ViewChild('ScanBarcodeModal') ScanBarcodeModal!: NgbPopover;
  @ViewChild('preInvoiceFactor') preInvoiceFactorModal!: NgbPopover;
  @ViewChild('addDrug') addDrugModal!: NgbPopover;

  @Input() endPoint: string;

  public taxFie: number = 0;
  public productType: any;
  public campaignTypeList: any[] = [];
  public searchLoading: boolean = false;
  public searchList: any[] = [];
  public companyList: any[] = [];
  public sellerList: any[] = [];
  public countMessage: string = ``;
  public inventoryCount: number = 0;
  public modalSuccessConfirm: boolean = false;
  public modalCredit: boolean = false;
  public modalLoading: boolean = false;
  public returnDescription: string = '';
  public modalIsOpen: boolean = false;
  public barcode: string = '';
  public action: PCTableActionInputModel;
  public searchRequestModel: PCSearchRequestModel;
  public requestModel: PCSearchRequestModel;
  public endPointUrl!: string;
  public paging?: TabelPaging;
  public searchPaging?: TabelPaging;
  public stockList: any[] = [];
  public stockItemList: any[] = [];
  public foundedStock: any;
  public destinationStockSelected: any;
  public preInvoiceRequestModel: PCSearchRequestModel;
  public preInvoicePaging?: TabelPaging;

  public activeAddModal: boolean = false;
  public thisBarcodeValue: DrugCode;
  public loadingModal: boolean = false;
  public backendJson: BuyImportRequestModal;

  public addDrugUrl: string = '';
  public genericAddDrugDisable: boolean = false;

  public modalConfirm: ModalConfirm = new ModalConfirm();

  public activeSearch: boolean = true;
  public activeGetBarcodeOnAdd: boolean = false;

  public factorImageList: any[] = [];
  public thisItem: any;
  public showAddButtonUploadImage: boolean = true;
  public buyDiscount: boolean = true;
  public TaxAlert: boolean = true;
  public monthName: string = '';
  public loading: boolean = false;
  public preInvoiceLoading: boolean = false;
  public stocks: any[] = [];
  public stockTypes: any[] = [];
  public organizations: any[] = [
    {
      id: 'current.id',
      name: 'current.name',
      persianName: 'current.persianName',
    },
  ];

  public filterData: FactorReportFilter;

  public onlineDiscount: number = 0;
  public partnerDiscount: number = 0;
  public cashThisItem: any;
  public creditThisItem: any;

  public modalDeleteConfirm: boolean = false;
  private focusableItems: FocusableHTMLElement[] = [];
  private rememberItem?: FocusableHTMLElement;
  @ViewChild(PcsettingModalComponent)
  pcsettingModalComponent!: PcsettingModalComponent;
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild(SearchBoxComponent)
  searchBoxComponent!: SearchBoxComponent;

  public confirmModalOpen: boolean = false;

  public ngOnInit(): void {

    this.generateUrl();
    forkJoin([this.getData(), this.getEntity()]).subscribe(
      ([dataResult, entityResult]) => {
        if (dataResult) {
          this.logger.addResponseLog(this.endPointUrl, dataResult, `Get All`);
          if (dataResult.succeeded) {
            let firstItemOnPage = dataResult.data?.firstItemOnPage || 1;

            if (dataResult.data?.pageCount! < dataResult.data?.pageNumber! && dataResult.data?.pageCount != 0) {
              this.requestModel.pageNumber = 1;
              this.getSingleData();
            }

            this.data = new PCTableInputModel(
              dataResult.data?.items,
              [
                {
                  name: 'FactorDetail',
                  className: 'btn-outline-primary',
                  icon: 'fa fa-eye',
                  condition: 'noEditable',
                },
                {
                  name: 'Returned',
                  className: 'btn-outline-danger',
                  icon: 'fa fa-undo',
                  condition: 'noEditable',
                },
                {
                  name: 'cash',
                  className: 'btn-outline-info',
                  icon: 'fa-solid fa-coins',
                  condition: 'noEditable',
                  secondCondition: 'payableId',
                },
                {
                  name: 'credit',
                  className: 'btn-outline-info',
                  icon: 'fa-regular fa-credit-card',
                  condition: 'noEditable',
                  secondCondition: 'payableId',
                },
                {
                  name: 'Lack',
                  className: 'btn-outline-success',
                  icon: 'fas fa-minus',
                  condition: 'noEditable',
                  secondCondition: 'haveShortage',
                },
                {
                  name: 'Edit',
                  className: 'btn-outline-primary',
                  icon: 'fas fa-edit',
                  condition: '!noEditable',
                },
                {
                  name: 'Delete',
                  className: 'btn-outline-danger',
                  icon: 'bx bx-trash',
                  condition: '!noEditable',
                },
              ],
              true,
              firstItemOnPage,
              this.requestModel.orderBy,
              this.requestModel.direction
            );

            this.paging = this.responseService.customizePaging(dataResult);
          }
        }

        if (entityResult) {
          this.logger.addResponseLog(
            this.endPoint == null ? '' : this.endPoint,
            entityResult,
            `Get Entity`
          );
          if (entityResult.succeeded) {
            let fields = this.apiService.convertStringToBoolean(
              entityResult.data.fields
            );

            fields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            this.fields = fields;
          }
        }

        setTimeout(() => {
          if (this.pcTableComponent) {
            this.pcTableComponent.InitPage();
          } else {
            console.error('PCTableComponent not found');
          }
        }, 2);

        setTimeout(() => {
          let selectStockPage = document.getElementById('selectStockPage');
          if (selectStockPage) {
            selectStockPage.classList.remove('animate__backInDown');
          }
        }, 2000);

        this.loading = false;
      },
      (error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
      }
    );
    if (this.endPoint == 'BuyFactor') {
      this.action.buttons.splice(4, 1);
    }
  }

  public checkValidation(): boolean {
    var isValid = true;
    if (
      this.editableItem.drugName == `` ||
      this.editableItem.drugName == null
    ) {
      this.editableItemMessage.drugName = `فیلد نام دارو اجباری است`;
      isValid = false;
    } else {
      this.editableItemMessage.drugName = ``;
    }
    if (this.editableItem.count == 0 || this.editableItem.count == null) {
      this.editableItemMessage.count = `فیلد تعداد دارو اجباری است`;
      isValid = false;
    } else {
      this.editableItemMessage.count = ``;
    }
    if (
      this.editableItem.expireDate == `` ||
      this.editableItem.expireDate == null
    ) {
      this.editableItemMessage.expireDate = `فیلد تاریخ انقضا اجباری است`;
      isValid = false;
    } else {
      const now = new Date();
      const sixMonthsAhead = new Date();
      const date = new Date(this.editableItem.expireDate);
      if (date <= sixMonthsAhead) {
        this.editableItemMessage.expireDate = `این دارو تاریخ گذشته است و امکان ثبت آن وجود ندارد`;
        isValid = false;
      } else {
        sixMonthsAhead.setMonth(now.getMonth() + 6);
        if (date < sixMonthsAhead) {
          if (this.editableItemMessage.allowLowExpireDate) {
            this.editableItemMessage.expireDate = ``;
          } else {
            this.modalConfirm.pageMessage = 'confirmLowExpireDate';
            this.modalConfirm.returnAcceptMethod = 'confirmLowExpireDate';
            this.modalConfirm.returnDenyMethod = 'NotConfirmLowExpireDate';
            this.confirmModalOpen = true;
            isValid = false;
          }
        } else {
          this.editableItemMessage.expireDate = ``;
        }
      }
    }
    if (this.editableItem.buyPrice == 0 || this.editableItem.buyPrice == null) {
      this.editableItemMessage.buyPrice = `فیلد قیمت خرید اجباری است`;
      isValid = false;
    } else {
      this.editableItemMessage.buyPrice = ``;
    }
    if (this.editableItem.stocks.length == 0) {
      if (
        this.editableItem.packageCount != null &&
        this.editableItem.lack != null &&
        this.editableItem.packageCount == this.editableItem.lack
      ) {
        this.editableItemMessage.stockId = ``;
      } else {
        this.editableItemMessage.stockId = `اطلاعات انبار اجباری است`;
        isValid = false;
      }
    } else {
      this.editableItemMessage.stockId = ``;
    }
    if (
      this.editableItem.sellPrice == 0 ||
      this.editableItem.sellPrice == null
    ) {
      this.editableItemMessage.sellPrice = `فیلد قیمت فروش اجباری است`;
      isValid = false;
    } else {
      this.editableItemMessage.sellPrice = ``;
    }
    if (this.editableItem.minimumCount == null) {
      this.editableItemMessage.minimumCount = `فیلد حداقل موجودی اجباری است`;
      isValid = false;
    } else {
      this.editableItemMessage.minimumCount = ``;
    }
    return isValid;
  }

  public completeSuccess() {
    this.modalSuccessConfirm = true;
    this.modalService.dismissAll();
    this.loadingModal = false;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Sort':
        this.loading = true;
        if (this.requestModel.orderBy == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.orderBy != event.data) {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == '') {
          this.requestModel.direction = 'asd';
        } else if (this.requestModel.direction == 'asd') {
          this.requestModel.direction = 'desc';
        } else {
          this.requestModel.direction = '';
          this.requestModel.orderBy = '';
        }

        this.requestModel.orderBy = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Search':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.search = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Paging':
        this.loading = true;
        this.requestModel.pageNumber = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'PageSize':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.requestModel.pageSize = event.data;
        this.generateUrl();
        this.getSingleData();
        break;
      case 'Reload':
        this.loading = true;
        this.requestModel.pageNumber = 1;
        this.filterData = new FactorReportFilter();
        this.generateUrl();
        this.getSingleData();
        break;
      case 'FactorDetail':
        this.getFactorDetail(event.data.id, this.factorDetailModalElement, true);
        break;
      case 'Filter':
        this.openModal(this.searchFilterModal);
        break;
      case 'Returned':
        this.getFactorDetail(event.data.id, this.factorReturnModalElement);
        break;
      case 'SuccessRemoveShortage':
        this.modalSuccessConfirm = true;
        this.loading = true;
        this.generateUrl();
        this.getSingleData();
        this.modalService.dismissAll();
        break;
      case 'Successed':
        this.modalSuccessConfirm = false;
        break;
      case 'cash':
        this.openModal(this.CashAddModal);
        this.cashThisItem = event.data;
        break;
      case 'closeCash':
        this.modalService.dismissAll();
        break;
      case 'closeUid':
        this.modalService.dismissAll();
        break;
      case 'SaveUid':
        if (event.data == undefined) {
          return;
        }
        this.editableItem.drugUIds = event.data;
        this.modalService.dismissAll();
        break;
      case 'CashMultiPayment':
        this.openModal(this.CashMultiPaymentModal);
        this.cashThisItem = event.data;
        break;
      case 'closeCashMultiPayment':
        this.modalService.dismissAll();
        break;
      case 'CreditMultiPayment':
        this.openModal(this.CreditMultiPaymentModal);
        this.creditThisItem = event.data;
        break;
      case 'closeCreditMultiPayment':
        this.modalService.dismissAll();
        break;
      case 'ScanBarcode':
        this.openModal(this.ScanBarcodeModal);
        break;
      case 'CloseScanBarcode':
        this.modalService.dismissAll();
        break;

      case 'Lack':
        this.getLackFactorDetail(event.data.id, this.removeLackModalElement);
        break;
      case 'credit':
        this.openModal(this.CreditAddModal);
        this.creditThisItem = event.data;
        break;
      case 'closeCredit':
        this.modalService.dismissAll();
        break;
      case 'NotConfirmSave':
        this.confirmModalOpen = false;
        break;

      case 'confirmLowExpireDate':
        this.confirmModalOpen = false;
        this.editableItemMessage.allowLowExpireDate = true;
        this.editableItemMessage.expireDate = ``;
        break;

      case 'NotConfirmLowExpireDate':
        this.editableItemMessage.expireDate = `مقدار تاریخ انقضا نمیتواند کمتر از 6 ماه باشد`;
        this.editableItemMessage.allowLowExpireDate = false;
        this.confirmModalOpen = false;
        break;

      case 'ReturnCompleted':
        this.modalService.dismissAll();
        this.modalSuccessConfirm = true;
        break;

      case 'Settings':
        this.pcsettingModalComponent.openSettingModal();
        break;

      case 'SubmitSetting':
        this.fields = event.data;
        if (this.pcTableComponent) {
          this.pcTableComponent.RebuildColumn();
        } else {
          console.error('PCTableComponent not found');
        }
        break;

      case 'Add':
        this.router.navigate(['Buy']);
        break;
      case 'ConfirmDelete':
        this.modalDeleteConfirm = false;
        this.submitDelete();
        break;
      case 'NotDelete':
        this.modalDeleteConfirm = false;
        break;
      case 'Delete':
        this.modalDeleteConfirm = true;
        this.thisValue = event.data;
        break;

      case 'Edit':
        this.database.setData(event.data, "Buy");
        this.router.navigate(['Buy']);
        break;
      default:
        break;
    }
  }

  public submitDelete() {
    try {
      this.loading = true;
      let url = `${this.endPoint}/${this.thisValue.id}`;

      this.apiService.deleteItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Delete`);
          if (result.succeeded) {
            this.getSingleData();
            this.modalSuccessConfirm = true;
            this.loading = false;
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => { }
      );
    } catch (e) {
      this.logger.addException(e, false);
    }
  }

  public ImportReturnFactor() {
    try {
      var backEndJson: any[] = [];

      var isValid = true;
      this.factorDetail.returnDrug.forEach((element) => {
        if (element.returnCount != null && element.returnCount > 0) {
          if (element.count == null) {
            this.logger.addError(
              'خطا در دریافت اطلاعات انبار صفحه را به روز کنید',
              false
            );
            return;
          }
          if (element.returnCount > element.count) {
            element.alertMessage =
              'مقدار مرجوعی نمیتواند بیشتر از موجودی انبار باشد';
            isValid = false;
          }

          if (element.description == null) {
            element.description = ' ';
          }
          let thisItem = {
            Count: element.returnCount,
            BuyFactorDetailId: element.buyFactorDetailId,
            InventoryDetailId: element.stockItemId,
            BuyFactorNumber: element.buyFactorNumber,
            Description: element.description,
          };

          backEndJson.push(thisItem);
        }
      });

      if (backEndJson.length == 0) {
        this.logger.addError('هیچ موردی برای مرجوع ثبت نشده اس ', false);
        return;
      }

      if (!isValid) {
        return;
      }

      console.log(backEndJson);

      this.loading = true;

      const url = `BuyReturn/BuyReturnImport`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      this.apiService.postItem(new ApiRequestModel(url, backEndJson)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            this.modalSuccessConfirm = true;
            this.modalService.dismissAll();
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => { }
      );
    } catch (error) {
      this.logger.addError(error, false);
    }
  }

  public openSettings() {
    this.pcsettingModalComponent.openSettingModal();
  }

  public generateUrl() {
    this.endPointUrl = `${this.endPoint}?pageNumber=${this.requestModel.pageNumber}&pageSize=${this.requestModel.pageSize}&paging=${this.requestModel.paging}&orderBy=${this.requestModel.orderBy}&direction=${this.requestModel.direction}&search=${this.requestModel.search}`;
  }

  public clearEditItem() {
    this.filterData = new FactorReportFilter();
  }

  public getSingleData() {
    try {
      if (
        !this.apiService.tokenValidation(new ApiRequestModel(this.endPointUrl))
      ) {
        return;
      }
      this.modalService.dismissAll();
      this.loading = true;
      this.apiService
        .getAllWithFilter(
          new ApiRequestModel(this.endPointUrl),
          this.filterData
        )
        .subscribe(
          (result) => {
            this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
            if (result.succeeded) {
              let firstItemOnPage = 1;
              if (result.data?.firstItemOnPage) {
                firstItemOnPage = result.data?.firstItemOnPage;
              }

              if (
                result.data?.pageCount != 0 &&
                result.data?.pageCount! < result.data?.pageNumber!
              ) {
                this.requestModel.pageNumber = 1;
                this.getSingleData();
              }

              this.data = new PCTableInputModel(
                result.data?.items,
                [
                  {
                    name: 'FactorDetail',
                    className: 'btn-outline-primary',
                    icon: 'fa fa-eye',
                    condition: 'noEditable',
                  },
                  {
                    name: 'Returned',
                    className: 'btn-outline-danger',
                    icon: 'fa fa-undo',
                    condition: 'noEditable',
                  },
                  {
                    name: 'cash',
                    className: 'btn-outline-info',
                    icon: 'fa-solid fa-coins',
                    condition: 'noEditable',
                    secondCondition: 'payableId',
                  },
                  {
                    name: 'credit',
                    className: 'btn-outline-info',
                    icon: 'fa-regular fa-credit-card',
                    condition: 'noEditable',
                    secondCondition: 'payableId',
                  },
                  {
                    name: 'Lack',
                    className: 'btn-outline-success',
                    icon: 'fas fa-minus',
                    condition: 'noEditable',
                    secondCondition: 'haveShortage',
                  },
                  {
                    name: 'Edit',
                    className: 'btn-outline-primary',
                    icon: 'fas fa-edit',
                    condition: '!noEditable',
                  },
                  {
                    name: 'Delete',
                    className: 'btn-outline-danger',
                    icon: 'bx bx-trash',
                    condition: '!noEditable',
                  },
                ],
                true,
                firstItemOnPage,
                this.requestModel.orderBy,
                this.requestModel.direction
              );
              this.paging = this.responseService.customizePaging(result);
              setTimeout(() => {
                let selectStockPage =
                  document.getElementById('selectStockPage');
                if (selectStockPage) {
                  selectStockPage.classList.remove('animate__backInDown');
                }
              }, 2 * 1000);
            } else {
              this.logger.addBackEndMessage(result);
            }
            this.loading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
    setTimeout(() => { }, 700);
    setTimeout(() => {
      let selectStockPage = document.getElementById('StockDetail');
      if (selectStockPage) {
        selectStockPage.classList.remove('animate__backInDown');
      }
    }, 2 * 1000);
  }

  public getData() {
    return this.apiService.getAll(new ApiRequestModel(this.endPointUrl)).pipe(
      catchError((error) => {
        this.apiService.AddErrorLog(error);
        this.loading = false;
        return of(null);
      })
    );
  }

  public getEntity() {
    return this.apiService
      .getEntity(
        new ApiRequestModel(
          this.endPoint,
          null,
          undefined,
          this.endPoint,
          'BuyFactor'
        )
      )
      .pipe(
        catchError((error) => {
          this.apiService.AddErrorLog(error);
          return of(null);
        })
      );
  }

  public getFactorDetail(
    itemID: string,
    modalName: any,
    withoutStock?: boolean
  ) {
    try {
      if (withoutStock == undefined) {
        withoutStock = false;
      }
      // if (this.factorDetail.id != null && this.factorDetail.id == itemID) {
      //   this.openModal(modalName);
      //   return;
      // }
      this.loading = true;
      let url = `${this.endPoint}/FactorDetail/${itemID}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {
            if (withoutStock) {
              this.mapFactorDetailWithoutStock(result, modalName);
            } else {
              this.mapFactorDetail(result, modalName);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getLackFactorDetail(
    itemID: string,
    modalName: any
  ) {
    try {

      this.loading = true;
      let url = `${this.endPoint}/FactorDetail/${itemID}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(this.endPointUrl, result, `Get All`);
          if (result.succeeded) {

            result.data.drugs = result.data.drugs
              .filter((current) => current.shortageCount > 0);
            this.mapFactorDetailWithoutStock(result, modalName);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  private mapFactorDetail(result: any, modalName: any) {
    this.factorDetail = _.cloneDeep(result.data);
    this.factorDetail.drugs = [];
    this.factorDetail.returnDrug = [];
    result.data.drugs.forEach((element) => {
      if (element.inventoryDetails.length == 0) {
        let newItem = new FactorStockItemDetailDrug();
        newItem.drugId = element.drugId;
        newItem.count = element.count / element.packageCount;
        newItem.shortageCount = element.shortageCount / element.packageCount;
        newItem.expireDate = element.expireDate;
        newItem.lot = element.lot;
        newItem.complimentary = element.complimentary;
        newItem.buyPrice = element.buyPrice;
        newItem.sellPrice = element.sellPrice;
        newItem.onlinePrice = element.onlinePrice;
        newItem.partnerPrice = element.partnerPrice;
        newItem.buyDiscountPersent = element.buyDiscountPersent;
        newItem.buyDiscount = element.buyDiscount;
        newItem.buyGift = element.buyGift;
        newItem.drugName = element.drugName;
        newItem.tax = element.tax;
        newItem.totalPrice = element.buyPrice * element.count;
        newItem.packageCount = element.packageCount;
        newItem.stockItemId = '';
        newItem.inventory = 0;
        newItem.buyFactorDetailId = element.id;
        newItem.buyFactorNumber = this.factorDetail.factorId;
        this.factorDetail.returnDrug.push(newItem);
      } else {
        element.inventoryDetails.forEach((elementStock) => {
          let newItem = new FactorStockItemDetailDrug();
          newItem.drugId = element.drugId;
          newItem.count = elementStock.count;
          newItem.shortageCount = element.shortageCount / element.packageCount;
          newItem.expireDate = elementStock.expireDate;
          newItem.lot = elementStock.lot;
          newItem.complimentary = element.complimentary;
          newItem.buyPrice = element.buyPrice;
          newItem.sellPrice = element.sellPrice;
          newItem.onlinePrice = element.onlinePrice;
          newItem.partnerPrice = element.partnerPrice;
          newItem.buyDiscountPersent = element.buyDiscountPersent;
          newItem.buyDiscount = element.buyDiscount;
          newItem.buyGift = element.buyGift;
          newItem.drugName = element.drugName;
          newItem.tax = element.tax;
          newItem.totalPrice = element.buyPrice * element.count;
          newItem.packageCount = element.packageCount;
          newItem.stockItemId = elementStock.id;
          newItem.inventory = elementStock.count;
          newItem.buyFactorDetailId = element.id;
          newItem.buyFactorNumber = this.factorDetail.factorId;
          this.factorDetail.returnDrug.push(newItem);
        });
      }
    });

    this.openModal(modalName);
  }

  private mapFactorDetailWithoutStock(result: any, modalName: any) {
    this.factorDetail = _.cloneDeep(result.data);
    this.factorDetail.drugs = [];
    this.factorDetail.returnDrug = [];

    this.factorDetail.returnDrug = result.data.drugs
      .map((current) => ({
        drugId: current.drugId,
        count: current.count / current.packageCount,
        shortageCount: current.shortageCount / current.packageCount,
        expireDate: current.expireDate,
        lot: current.lot,
        complimentary: current.complimentary,
        buyPrice: current.buyPrice,
        sellPrice: current.sellPrice,
        onlinePrice: current.onlinePrice,
        partnerPrice: current.partnerPrice,
        buyDiscountPersent: current.buyDiscountPersent,
        buyDiscount: current.buyDiscount,
        buyGift: current.buyGift,
        drugName: current.drugName,
        tax: current.tax,
        // packageCount: (current.count ?? 1) / (current.drugPackageCount ?? 1),
        totalPrice: current.count * (current.buyPrice ?? 0) -
          (current.buyDiscount ?? 0) +
          (current.tax ?? 0),
        packageCount: current.packageCount,
        stockItemId: '',
        inventory: 0,
        buyFactorDetailId: current.id,
        buyFactorNumber: '',
      }));

    this.openModal(modalName);
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public openModal(content: any) {
    try {
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          },
          (reason) => {
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          }
        );
    } catch (error) { }
  }

  public getSeller(drugDistributorId: string) {
    try {
      this.loading = true;
      let url = `Seller/SpecificCompany/${drugDistributorId}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getWitoutPage(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (!result.data) {
            this.sellerList = [];
          }
          if (result.succeeded) {
            if (result.data) {
              this.sellerList = result.data.map((current) => ({
                id: current.id,
                name:
                  current.mobileNumber == null
                    ? current.firstName + ' ' + current.lastName
                    : current.firstName +
                    ' ' +
                    current.lastName +
                    ' - ' +
                    current.mobileNumber,
                persianName:
                  current.mobileNumber == null
                    ? current.firstName + ' ' + current.lastName
                    : current.firstName +
                    ' ' +
                    current.lastName +
                    ' - ' +
                    current.mobileNumber,
              }));
            } else {
              this.sellerList = [];
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public changeCompany(event) {
    if (event.id) {
      this.backendJson.drugDistributorId = event.id;
      this.getSeller(this.backendJson.drugDistributorId!);
    }
  }

  public getStockData() {
    try {
      this.loading = true;
      let url = `Stock?pageNumber=1&pageSize=1000&paging=true&orderBy=&direction=asc`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.stockList = result.data?.items.map((current) => ({
              id: current.id,
              name: current.name,
              persianName: current.title,
            }));
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  // public checkAddDrugValidation(): boolean {
  //   const requiredMessage = 'وارد کردن این فیلد اجباری می باشد';
  //   const minLengthMessage = 'مقدار این فیلد نمیتواند کمتر از 3 کاراکتر باشد';
  //   let isSucceed = true;

  //   if (this.thisValue == null) {
  //     return false;
  //   }

  //   if (this.thisBarcodeValue == null || this.thisValue == null) {
  //     return false;
  //   }

  //   if (this.thisValue.name == null || this.thisValue.name == '') {
  //     this.thisValue.nameHint = requiredMessage;
  //     isSucceed = false;
  //   } else if (this.thisValue.name.length < 3) {
  //     this.thisValue.nameHint = minLengthMessage;
  //     isSucceed = false;
  //   } else {
  //     this.thisValue.nameHint = undefined;
  //   }

  //   if (
  //     this.thisValue.persianName == null ||
  //     this.thisValue.persianName == ''
  //   ) {
  //     this.thisValue.persianNameHint = requiredMessage;
  //     isSucceed = false;
  //   } else if (this.thisValue.persianName.length < 3) {
  //     this.thisValue.persianNameHint = minLengthMessage;
  //     isSucceed = false;
  //   } else {
  //     this.thisValue.persianNameHint = undefined;
  //   }

  //   if (
  //     this.thisValue.drugPackageCount == null ||
  //     this.thisValue.drugPackageCount.toString() == '' ||
  //     this.thisValue.drugPackageCount == 0
  //   ) {
  //     this.thisValue.drugPackageHint = requiredMessage;
  //     isSucceed = false;
  //   } else {
  //     this.thisValue.drugPackageHint = undefined;
  //   }

  //   if (this.thisValue.buyPrice == null || this.thisValue.buyPrice == 0) {
  //     this.thisValue.buyPriceHint = requiredMessage;
  //     isSucceed = false;
  //   } else if (this.thisValue.buyPrice < 500) {
  //     this.thisValue.buyPriceHint = minLengthMessage;
  //     isSucceed = false;
  //   } else {
  //     this.thisValue.buyPriceHint = undefined;
  //   }

  //   if (this.thisValue.sellPrice == null || this.thisValue.sellPrice == 0) {
  //     this.thisValue.costHint = requiredMessage;
  //     isSucceed = false;
  //   } else if (this.thisValue.sellPrice < 500) {
  //     this.thisValue.costHint = minLengthMessage;
  //     isSucceed = false;
  //   } else {
  //     this.thisValue.costHint = undefined;
  //   }

  //   return isSucceed;

  // }

  // private toJSON(): FactorDetailDrug {
  //   if (this.thisValue == null) {
  //     return new FactorDetailDrug();
  //   }

  //   return {
  //     id: this.thisValue.id,
  //     drugId: this.thisValue.drugId,
  //     count: this.thisValue.count,
  //     shortageCount: this.thisValue.shortageCount,
  //     expireDate: this.thisValue.expireDate,
  //     lot: this.thisValue.lot,
  //     complimentary: this.thisValue.complimentary,
  //     buyPrice: this.thisValue.buyPrice,
  //     sellPrice: this.thisValue.sellPrice,
  //     onlinePrice: this.thisValue.onlinePrice,
  //     partnerPrice: this.thisValue.partnerPrice,
  //     buyDiscountPersent: this.thisValue.buyDiscountPersent,
  //     buyDiscount: this.thisValue.buyDiscount,
  //     buyGift: this.thisValue.buyGift,
  //     drugName: this.thisValue.drugName,
  //     tax: this.thisValue.tax,
  //     packageCount: this.thisValue.packageCount,
  //     inventoryDetails: this.forEach((element) => {
  //       element.camelCaseName = this.apiService.camelCase(
  //         element.fieldName
  //       );
  //     });
  //   };
  // }

  // public saveAdd() {
  //   try {
  //     if (!this.checkAddDrugValidation()) {
  //       return;
  //     }

  //     this.loadingModal = true;
  //     let url = `BuyFactor/ReduceShortage`;

  //     let backendJson={
  //       id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  //       count: 0,
  //       drugPackageCount: 0,
  //       expireDate: "2025-05-11T05:18:12.865Z",
  //       lot: "string",
  //       inventoryDetails: [
  //         {
  //           stockId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  //           count: 0
  //         }
  //       ]
  //     }
  //     const backendJson = this.toJSON();
  //     paeen kenar url  ,backendJson
  //     this.apiService.postItem(new ApiRequestModel(url)).subscribe(
  //       (result) => {
  //         this.completeSuccess();
  //       },
  //       (error) => {
  //         this.apiService.AddErrorLog(error);
  //         this.loadingModal = false;
  //       },
  //       () => {
  //         this.loadingModal = false;
  //       }
  //     );
  //   } catch (e) {
  //     this.logger.addException(e, true);
  //     this.loadingModal = false;
  //   }
  // }
}

